module.exports = __webpack_public_path__ + "img/file77.5f0cd06f.png";